// extracted by mini-css-extract-plugin
export default {"container":"ProductsMenu_container__-PBxs","menuSection":"ProductsMenu_menuSection__vm2FF","optionList":"ProductsMenu_optionList__ofpvx"};